
import { CheckCircle, Info } from "lucide-react";
import ValueProposition from "@/components/ValueProposition";

const ConsultingApproach = () => {
  return (
    <ValueProposition
      id="katalysator-fuehrung"
      title="Mein Consulting-Ansatz: Katalysator-Führung"
      description="In einer Zeit zunehmender Komplexität brauchen Unternehmen eine neue Form des Leaderships. Das Katalysator-Führungskonzept verbindet wirtschaftliche Expertise mit tiefem Verständnis für menschliche Dynamiken – für nachhaltige Unternehmensentwicklung und messbare Resultate."
      image="/lovable-uploads/8ec5b138-c75c-4a06-bc73-e830d85c9f29.png"
      backgroundColor="bg-white"
      highlightWords={true}
      textAlignment="text-left"
    >
      <div className="grid gap-8 mt-8">
        <div className="bg-white p-6 rounded-xl shadow-soft">
          <div className="flex flex-col items-center mb-3">
            <div className="h-10 w-10 bg-primary/10 rounded-full flex items-center justify-center text-primary mb-2">
              <CheckCircle className="h-5 w-5" />
            </div>
            <h3 className="text-xl font-semibold text-joerg-800 text-center">Katalysator statt Manager</h3>
          </div>
          <p className="text-joerg-600 text-left">
            Während klassische Manager kontrollieren und anweisen, wirkt der Katalysator-Führungsstil als Beschleuniger für Potenzialentfaltung. 
            Führungskräfte schaffen Rahmenbedingungen, in denen Mitarbeiter eigenverantwortlich Höchstleistungen erbringen können.
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-soft">
          <div className="flex flex-col items-center mb-3">
            <div className="h-10 w-10 bg-primary/10 rounded-full flex items-center justify-center text-primary mb-2">
              <CheckCircle className="h-5 w-5" />
            </div>
            <h3 className="text-xl font-semibold text-joerg-800 text-center">Balance von Ratio & Emotion</h3>
          </div>
          <p className="text-joerg-600 text-left">
            Erfolgreiche Führung verbindet analytisches Denken mit emotionaler Intelligenz. Das Katalysator-Modell integriert beide Dimensionen 
            und ermöglicht so fundierte Entscheidungen, die wirtschaftlich überzeugen und menschlich nachhaltig sind.
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-soft">
          <div className="flex flex-col items-center mb-3">
            <div className="h-10 w-10 bg-primary/10 rounded-full flex items-center justify-center text-primary mb-2">
              <CheckCircle className="h-5 w-5" />
            </div>
            <h3 className="text-xl font-semibold text-joerg-800 text-center">Nachhaltige Transformation</h3>
          </div>
          <p className="text-joerg-600 text-left">
            Im Gegensatz zu kurzfristigen Change-Prozessen zielt Katalysator-Führung auf langfristige, selbsttragende Veränderung ab. 
            Sie aktiviert intrinsische Motivation und schafft Strukturen, die kontinuierliches Wachstum und Innovation fördern.
          </p>
        </div>
      </div>
      
      {/* Pseudonymisiertes Testimonial mit Hinweis */}
      <div className="mt-10 bg-joerg-50 p-6 rounded-xl border-l-4 border-primary italic">
        <p className="text-joerg-700 mb-4">
          "Jörgs Art zu führen hat unser Team nachhaltig verändert. Seine humorvolle, ehrliche und direkte Art schafft Orientierung 
          und gibt klare Richtung, selbst bei kritischen Themen. Er versteht es, die Interessen aller Beteiligten zu berücksichtigen 
          und dabei authentisch zu bleiben."
        </p>
        <p className="text-joerg-800 font-medium not-italic">
          — Ehemaliges Teammitglied, MKS GmbH
        </p>
        <div className="mt-4 text-sm text-joerg-500 flex items-center not-italic">
          <Info className="h-4 w-4 mr-2 text-joerg-400 flex-shrink-0" />
          <span>Aus Datenschutzgründen wurden die Namen der Kunden und Unternehmensbezeichnungen pseudonymisiert. Die beruflichen Positionen entsprechen den tatsächlichen Tätigkeitsfeldern.</span>
        </div>
      </div>
    </ValueProposition>
  );
};

export default ConsultingApproach;
